import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import LottieView from './Lottie';

import alyxAnimation from './alyx.json';
import { ALYX_FRAMES_BY_STATE } from './AlexStates';

/**
 * This component is responsible for triggering the correct Alyx Lottie
 * animations at the correct time.
 */
const AlexLottie = ({ currentState, shouldAnimate }) => {
    const animationRef = useRef(null);
    const settleTimer = useRef(null);

    useEffect(() => {
        if (animationRef.current) {
            animationRef.current.reset();
        }
        return () => {
            if (animationRef.current) {
                animationRef.current.pause();
            }
            clearTimeout(settleTimer.current);
        };
    }, []);

    useEffect(() => {
        // Clear anything that was settling before
        clearTimeout(settleTimer.current);
        const [animatedFrames, staticFrames] = ALYX_FRAMES_BY_STATE[currentState];
        if (shouldAnimate) {
            animationRef.current.play(animatedFrames[0], animatedFrames[1]);
            // Settle this animation after 5 seconds
            settleTimer.current = setTimeout(() => {
                animationRef.current.play(staticFrames[0], staticFrames[1]);
            }, 5000);
        } else {
            animationRef.current.play(staticFrames[0], staticFrames[1]);
        }
    }, [currentState]);

    return (
        <LottieView
            ref={animationRef}
            style={{
                width: 215,
                height: 116,
            }}
            source={alyxAnimation}
            loop
        />
    );
};

AlexLottie.propTypes = {
    currentState: PropTypes.number.isRequired,
    shouldAnimate: PropTypes.bool,
};

AlexLottie.defaultProps = {
    shouldAnimate: false,
};

export default AlexLottie;
